import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FaBell} from 'react-icons/fa';
import {getNotifications, readNotification} from '../api';
import {useTranslation} from 'react-i18next';

const NotificationBell = ({token, history}) => {
  const {t, i18n} = useTranslation();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(async () => {
    if (!token) return;
    const response = await getNotifications(token, 8);
    if (response.status === 200) {
      setItems(response.json.items || []);
      setUnread(response.json.unread || 0);
    }
  }, [token]);

  useEffect(() => {
    refresh();
    const timer = window.setInterval(refresh, 60000);
    return () => window.clearInterval(timer);
  }, [refresh]);

  const openNotification = item => async event => {
    event.preventDefault();
    if (!item.read) await readNotification(item.id, token);
    setOpen(false);
    if (item.actionUrl) history.push(item.actionUrl);
    else history.push('/messages');
    refresh();
  };

  return <div className="notification-bell-skywork">
    <button type="button" className="notification-bell-skywork__button" aria-label={t('NOTIFICATION_BELL_LABEL', {count: unread})} onClick={() => setOpen(value => !value)}>
      <FaBell aria-hidden="true"/>{unread > 0 ? <span>{unread > 99 ? '99+' : unread}</span> : null}
    </button>
    {open ? <div className="notification-bell-skywork__panel">
      <div className="notification-bell-skywork__head"><strong>{t('NOTIFICATIONS')}</strong><button type="button" onClick={() => { setOpen(false); history.push('/messages'); }}>{t('VIEW_ALL')}</button></div>
      {items.length ? items.map(item => <a key={item.id} className={item.read ? '' : 'is-unread'} href={item.actionUrl || '/messages'} onClick={openNotification(item)}>
        <strong>{item.title}</strong><span>{item.body}</span><small>{new Date(item.createdAt).toLocaleString(i18n.language)}</small>
      </a>) : <p className="notification-bell-skywork__empty">{t('NO_NEW_NOTIFICATIONS')}</p>}
    </div> : null}
  </div>;
};

NotificationBell.propTypes = {token: PropTypes.string, history: PropTypes.object.isRequired};
NotificationBell.defaultProps = {token: null};
export default NotificationBell;
